import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import "./plugins/element.js";
import "./styles/global.scss";
import "./global/layouts.js";
import "./global/filters.js";
import "./global/components";
import "./vendors";
import i18n from "./i18n";
import { createProvider } from "./vue-apollo";
import VueBus from "./vue-bus.js";
import Permissions from "./plugins/permissions";

Vue.use(Permissions);
Vue.use(VueBus);
Vue.config.productionTip = false;

window.vue = new Vue({
	router,
	i18n,
	apolloProvider: createProvider(),
	render: h => h(App)
}).$mount("#app");
